<template>
  <div class="center-bottom">
    <div class="qusetion-report">
      <img :src="require('@/assets/daping/zxsbwt.png')" />
    </div>
    <div style="position: relative">
      <div class="leftArrow">
        <img :src="require('@/assets/daping/jiantou.png')" @click="arrowClick('left')" />
      </div>
      <el-carousel
        trigger="click"
        :autoplay="true"
        :interval="5000"
        arrow="never"
        :loop="true"
        indicator-position="none"
        ref="cardShow"
        style="margin-left: 30px"
      >
        <el-carousel-item v-for="(itemOne, index) in fourNum(listData)" :key="index">
          <div class="main-content">
            <div class="item flex">
              <div>
                <img
                  class="imgPic"
                  v-if="listData[index * 4].picture"
                  :src="listData[index * 4].picture"
                />
                <img v-else class="imgPic" :src="require('@/assets/daping/imgPic.jpg')" />
              </div>
              <div>
                <div class="flex algin-center">
                  <!-- v-if="listData[index * 4].state == '待处置'"  -->
                  <div class="yichuzhi">
                    {{ listData[index * 4].state }}
                  </div>
                  <!-- <div v-if="listData[index * 4].state == '已处置'" class="yichuzhi">
                    {{ listData[index * 4].state }}
                  </div> -->
                  <div class="name" :title="listData[index * 4].taskDetail" @click="detailClick(listData[index * 4])">
                    {{ listData[index * 4].taskDetail }}
                  </div>
                </div>
                <div>
                  <div
                    class="content_tga"
                    v-for="(item) in listNumber"
                    :key="item.id"
                  >
                    <div class="left flex">
                      <img :src="item.img" alt="" class="mechanism" />

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4][item.valueLi] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_tga">
                    <div class="left flex">
                      <img
                        :src="require('@/assets/daping/ico-address.svg')"
                        alt=""
                        class="mechanism"
                      />

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4].reportAddress }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tongzhi flex">
                <img :src="require('@/assets/daping/ico-tz.svg')" />
                <span> {{ listData[index * 4].date }}截止 </span>
              </div> -->
            </div>
            <div class="item flex" v-if="listData.length > index * 4 + 1">
              <div>
                <img
                  class="imgPic"
                  v-if="listData[index * 4 + 1].picture"
                  :src="listData[index * 4 + 1].picture"
                />
                <img v-else class="imgPic" :src="require('@/assets/daping/imgPic.jpg')" />
              </div>
              <div>
                <div class="flex algin-center">
                  <!-- v-if="listData[index * 4 + 1].state == '待处置'" -->
                  <div class="yichuzhi">
                    {{ listData[index * 4 + 1].state }}
                  </div>
                  <!-- <div v-if="listData[index * 4].state == '已处置'" class="yichuzhi">
                    {{ listData[index * 4 + 1].state }}
                  </div> -->
                  <div class="name" :title="listData[index * 4 + 1].taskDetail" @click="detailClick(listData[index * 4 + 1])">
                    {{ listData[index * 4 + 1].taskDetail }}
                  </div>
                </div>
                <div>
                  <div
                    class="content_tga"
                    v-for="(item) in listNumber"
                    :key="item.id"
                  >
                    <div class="left flex">
                      <img :src="item.img" alt="" class="mechanism" />
                      <!-- <div class="inspect">{{ item.name }}</div> -->

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 1][item.valueLi] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_tga">
                    <div class="left flex">
                      <img
                        :src="require('@/assets/daping/ico-address.svg')"
                        alt=""
                        class="mechanism"
                      />

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 1].reportAddress }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tongzhi flex">
                <img :src="require('@/assets/daping/ico-tz.svg')" />
                <span> {{ listData[index * 4].date }}截止 </span>
              </div> -->
            </div>
            <div class="item flex" v-if="listData.length > index * 4 + 2">
              <div>
                <img
                  class="imgPic"
                  v-if="listData[index * 4 + 2].picture"
                  :src="listData[index * 4 + 2].picture"
                />
                <img v-else class="imgPic" :src="require('@/assets/daping/imgPic.jpg')" />
              </div>
              <div>
                <div class="flex algin-center">
                  <!-- v-if="listData[index * 4 + 2].state == '待处置'"  -->
                  <div class="yichuzhi">
                    {{ listData[index * 4].state }}
                  </div>
                  <!-- <div v-if="listData[index * 4 + 2].state == '已处置'" class="yichuzhi">
                    {{ listData[index * 4 + 2].state }}
                  </div> -->
                  <div class="name" :title="listData[index * 4 + 2].taskDetail" @click="detailClick(listData[index * 4 + 2])">
                    {{ listData[index * 4 + 2].taskDetail }}
                  </div>
                </div>
                <div>
                  <div
                    class="content_tga"
                    v-for="(item) in listNumber"
                    :key="item.id"
                  >
                    <div class="left flex">
                      <img :src="item.img" alt="" class="mechanism" />
                      <!-- <div class="inspect">{{ item.name }}</div> -->

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 2][item.valueLi] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_tga">
                    <div class="left flex">
                      <img
                        :src="require('@/assets/daping/ico-address.svg')"
                        alt=""
                        class="mechanism"
                      />

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 2].reportAddress }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tongzhi flex">
                <img :src="require('@/assets/daping/ico-tz.svg')" />
                <span> {{ listData[index * 4].date }}截止 </span>
              </div> -->
            </div>
            <div class="item flex" v-if="listData.length > index * 4 + 3">
              <div>
                <img
                  class="imgPic"
                  v-if="listData[index * 4 + 3].picture"
                  :src="listData[index * 4 + 3].picture"
                />
                <img v-else class="imgPic" :src="require('@/assets/daping/imgPic.jpg')" />
              </div>
              <div>
                <div class="flex algin-center">
                  <!-- v-if="listData[index * 4 + 3].state == '待处置'"  -->
                  <div class="yichuzhi">
                    {{ listData[index * 4 + 3].state }}
                  </div>
                  <!-- <div v-if="listData[index * 4 + 3].state == '已处置'" class="yichuzhi">
                    {{ listData[index * 4 + 3].state }}
                  </div> -->
                  <div class="name" :title="listData[index * 4 + 3].taskDetail" @click="detailClick(listData[index * 4 + 3])">
                    {{ listData[index * 4 + 3].taskDetail }}
                  </div>
                </div>
                <div>
                  <div
                    class="content_tga"
                    v-for="(item) in listNumber"
                    :key="item.id"
                  >
                    <div class="left flex">
                      <img :src="item.img" alt="" class="mechanism" />
                      <!-- <div class="inspect">{{ item.name }}</div> -->

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 3][item.valueLi] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_tga">
                    <div class="left flex">
                      <img
                        :src="require('@/assets/daping/ico-address.svg')"
                        alt=""
                        class="mechanism"
                      />

                      <div class="inspect_value flex">
                        <div>
                          {{ listData[index * 4 + 3].reportAddress }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tongzhi flex">
                <img :src="require('@/assets/daping/ico-tz.svg')" />
                <span> {{ listData[index * 4].date }}截止 </span>
              </div> -->
            </div>
          </div>
        </el-carousel-item>
        <template #arrow="arrow">
          <button @click="arrow.goCarousel(1)">
            <!-- 这里可以是自定义的左箭头图标 -->
            <i class="el-icon-arrow-left"></i>
          </button>
          <button @click="arrow.goCarousel(-1)">
            <!-- 这里可以是自定义的右箭头图标 -->
            <i class="el-icon-arrow-right"></i>
          </button>
        </template>
      </el-carousel>
      <div class="rightArrow">
        <img :src="require('@/assets/daping/jiantou.png')" @click="arrowClick('right')" />
      </div>
    </div>

    <reportDetail v-if="reportDialogVisible" :dialogVisible.sync="reportDialogVisible" :formList="formList"></reportDetail>
  </div>
</template>
<script>
import { extendBigScreenLastReportList } from "@/api/daping.js";
import reportDetail from "./components/reportDetail.vue"
export default {
  name: "index",
  components: {
    reportDetail
  },
  data() {
    return {
      listData: [],
      listNumber: [
        {
          name: "联系人",
          number: 5,
          img: require("@/assets/daping/ico-sbr.svg"),
          valueLi: "reportUserName",
        },
        {
          name: "联系方式",
          number: 5,
          img: require("@/assets/daping/ico-lxfs.svg"),
          valueLi: "reportUserTel",
        },
        {
          name: "时间",
          number: 5,
          img: require("@/assets/daping/ico-sj.svg"),
          valueLi: "reportTime",
        },

        // {
        //   name: "1地址",
        //   number: 5,
        //   img: require("@/assets/daping/ico-sj.svg"),
        //   valueLi: "reportAddress",
        // }
      ],
      reportDialogVisible: false,
      formList: {}
    };
  },
  mounted() {
    this.extendBigScreenLastReportList();
  },
  methods: {
    async extendBigScreenLastReportList() {
      let res = await extendBigScreenLastReportList({
        page: 1,
        size: 12,
      });
      if (res.data.code == 200) {
        this.listData = res.data.data && res.data.data.records;
        if (this.listData.length > 0) {
          this.listData.forEach((item) => {
            if (item.fileJson) {
              if (JSON.parse(item.fileJson).length) {
                item.picture =
                  JSON.parse(item.fileJson) && JSON.parse(item.fileJson)[0].url;
              } else {
                item.picture = "";
              }
            } else {
              item.picture = "";
            }
            if (item.fileJsonZip) {
              if (JSON.parse(item.fileJsonZip).length) {
                item.picture =
                  process.env.VUE_APP_API_IMG_PATH +
                  JSON.parse(item.fileJsonZip)[0].filePath;
              }
            }
          });
        }
      }
    },
    fourNum(list) {
      // 循环4个
      let nums;
      if (list.length % 4 == 0) {
        //可以控制一页循环几个
        nums = list.length / 4;
      } else {
        nums = parseInt(list.length / 4) + 1;
      }
      return nums;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
      } else {
        this.$refs.cardShow.prev();
      }
    },
    detailClick(item) {
      this.reportDialogVisible = true;
      this.formList = item;
    }
  },
};
</script>
<style scoped lang="less">
.center-bottom {
  // margin-top: 1076px;
  .qusetion-report {
    // margin-bottom: 16px;
    img {
      width: 357px;
      height: 47px;
    }
  }
}
.flex {
  display: flex;
}
.main-content {
  display: flex;
  justify-content: space-between;
  width: 1450px;
  .item {
    width: 24%;
    color: #fff;
    background: url("~@/assets/daping/zxsbwt2.png") center center no-repeat;
    background-size: 100% 100%;
    // width: 350px;
    height: 222px;
    padding: 20px 10px;
    position: relative;
    .daichuzhi {
      background: rgba(235, 90, 90, 0.2);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #eb5a5a;
      height: 22px;
      line-height: 22px;
      padding: 0 4px;
      margin: 0 12px;
    }
    .yichuzhi {
      background: rgba(99, 218, 161, 0.2);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #63daa1;
      height: 22px;
      line-height: 22px;
      padding: 0 4px;
      margin: 0 12px;
    }
    .name {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 18px;
      color: #f3f8ff;
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .name:hover {
      color: #01e8fe;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
      text-decoration-line: underline;
    }
    .imgPic {
      width: 72px;
      height: 72px;
      border-radius: 4px;
    }
    .tongzhi {
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(0, 163, 255, 0) 0%,
        rgba(0, 163, 255, 0.3) 46%,
        rgba(0, 163, 255, 0) 100%
      );
      position: absolute;
      bottom: 0px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #01e8fe;
      line-height: 22px;
      align-items: center;
      padding: 7px 90px;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
  .item:first-child {
    margin-top: 20px;
  }
  .item:last-child {
    margin-top: 20px;
  }
}

.content_tga {
  margin: 10px 0 0 12px;
  .left {
    margin-bottom: 6px;
  }
  .mechanism {
    width: 16px;
    height: 18px;
    margin-right: 12px;
  }
  .inspect_value {
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 14px;
    color: #adc2d3;
  }
}
.algin-center {
  align-items: baseline;
}

.leftArrow {
  position: absolute;
  left: -15px;
  top: 80px;
  z-index: 99;
  img {
    width: 56px;
    height: 108px;
  }
}
.rightArrow {
  position: absolute;
  right: -10px;
  top: 80px;
  z-index: 99;
  img {
    width: 56px;
    height: 108px;
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/bottom.vue